import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import foodSafetyService from '../../services/foodSafetyService';
import PlanSnapshotView from './FoodSafetySnapshotView';

export default function FoodSafetyPrintPage() {
  const { planType } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');
  const backTo = from === 'index' ? '/sqf/food-safety' : `/sqf/food-safety/${planType}`;
  const backLabel = from === 'index' ? '← Back to Plans' : '← Back to Editor';
  const [data, setData]       = useState(null);
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    foodSafetyService.getPlanSnapshot(planType)
      .then(setData)
      .catch(err => setError(err?.response?.data?.message || 'Failed to load plan snapshot.'))
      .finally(() => setLoading(false));
  }, [planType]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="text-center text-muted">
          <div className="spinner-border mb-3" />
          <div>Loading plan…</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ maxWidth: 600, margin: '80px auto', padding: '0 24px', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
        <h4 className="fw-bold mb-2">Cannot Load Print View</h4>
        <p className="text-muted">{error}</p>
        <button className="btn btn-outline-secondary btn-sm mt-2" onClick={() => navigate(backTo)}>
          ← Back
        </button>
      </div>
    );
  }

  return <PlanSnapshotView snapshot={data.snapshot} version={data.version} showPrint showBack backTo={backTo} backLabel={backLabel} />;
}
